<gc-modal
  [headerTitle]="'signingConfirmationModal.headerTitle' | translate"
  [showCloseIcon]="false"
  [closeOnOutsideClick]="false"
  [primaryButtonText]="'signingConfirmationModal.return' | translate"
  [secondaryButtonText]="'signingConfirmationModal.download' | translate"
  [secondaryButtonIsLoading]="downloadPdfLoadingState()"
  (primaryButtonClicked)="handleReturnToReport()"
  (secondaryButtonClicked)="handleDownloadReport()"
>
  <div class="modal-content">
    <gc-icon [iconName]="'circleCheck'" [color]="'success'" [size]="'large'" />
    <gc-text [variant]="'smallHeading'">{{
      'signingConfirmationModal.title' | translate
    }}</gc-text>
    <gc-text [variant]="'largeParagraph'">{{
      'signingConfirmationModal.paragraphV2' | translate
    }}</gc-text>
  </div>

  <app-feedback-alert />
</gc-modal>
